import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row full-width justify-center" }
const _hoisted_2 = {
  class: "text-white q-pa-sm",
  href: "https://www.talentsconnect.com/impressum",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_3 = {
  class: "text-white q-pa-sm",
  href: "https://www.talentsconnect.com/datenschutzerklaerung",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_4 = { class: "copyright text-center q-pa-md q-mt-xs bg-secondary" }



const name = 'BrandFooter';

export default /*#__PURE__*/_defineComponent({
  __name: 'SmallFooter',
  props: ['showTermsOfUse'],
  setup(__props) {

const { showTermsOfUse } = __props;

function currentYear() {
  return new Date().getFullYear();
}


return (_ctx: any,_cache: any) => {
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    elevated: "",
    class: "bg-secondary text-white q-pt-md q-mt-lg"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 1),
        _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('message.privacyPolicyFLbl')), 1),
        _withDirectives(_createElementVNode("a", {
          class: "text-white q-pa-sm",
          href: "https://www.pitchyou.de/nutzungsbedingungen",
          target: "_blank",
          rel: "noopener noreferrer"
        }, _toDisplayString(_ctx.$t('message.termsOfUseFLbl')), 513), [
          [_vShow, __props.showTermsOfUse]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, " © " + _toDisplayString(currentYear()) + " TalentsConnect Operations GmbH ", 1)
    ]),
    _: 1
  }))
}
}

})